import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Mail } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-bank-statement/admin`;

export const StatementEmailsAdmin = ({ token }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    axios.get(`${API}/runs`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setD(r.data)).catch(() => {});
  }, [token]);
  useEffect(() => { load(); }, [load]);
  const send = async () => {
    setBusy(true);
    try {
      const r = (await axios.post(`${API}/send-now`, {}, { headers: { Authorization: `Bearer ${token}` } })).data;
      toast.success(`${r.month}: ${r.sent.length} sent, ${r.skipped.length} skipped, ${r.failed.length} failed`); load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Send failed'); }
    setBusy(false);
  };
  const last = d?.runs?.[0];
  return (
    <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 space-y-3" data-testid="statement-emails-admin">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-white font-semibold flex items-center gap-2"><Mail className="w-5 h-5 text-emerald-400" /> Monthly statement emails</h3>
        <button onClick={send} disabled={busy} className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white rounded-lg text-sm font-semibold flex items-center gap-2" data-testid="statement-send-now-btn">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Send last month's now
        </button>
      </div>
      <p className="text-sm text-slate-400">Sent automatically on the 1st to holders who switched them on: <span className="text-white" data-testid="statement-opted-in-count">{d?.opted_in ?? '-'}</span> opted in. Each holder gets each month once; test accounts are skipped.</p>
      {last && <p className="text-xs text-slate-500" data-testid="statement-last-run">Last run {new Date(last.at).toLocaleString()} for {last.month}: {last.sent.length} sent, {last.skipped.length} skipped, {last.failed.length} failed</p>}
    </div>
  );
};
